// Review text is clamped to a few lines; show "Read more" only when it's actually cut off.
if (!customElements.get('tt-review-text')) {
  customElements.define(
    'tt-review-text',
    class TTReviewText extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.tt-review__text');
        this.button = this.querySelector('.tt-review__more');
        if (!this.text || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());
        this.observer = new ResizeObserver(() => this.check());
        this.observer.observe(this.text);
        if (document.fonts) document.fonts.ready.then(() => this.check());
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      check() {
        if (this.classList.contains('is-expanded')) return;
        this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
      }

      toggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.button.setAttribute('aria-expanded', expanded);
        this.button.textContent = expanded ? this.dataset.less : this.dataset.more;
      }
    }
  );
}
